import { useContext } from 'react'
import { ScrollControlContext } from '@contexts/ScrollControlContext'

export function useScrollControl() {
  const context = useContext(ScrollControlContext)

  if (!context.setIsScrollingContent) {
    throw new Error(
      'useScrollControl must be used within ScrollControlProvider',
    )
  }

  return context
}
